/* City of Knowledge — Base JS v6 */
(function(){
  'use strict';

  // ── PREDICTIVE SEARCH MODAL OVERLAY ───────────────────────────
  var searchOverlay = document.getElementById('SearchModalOverlay');
  var searchInput   = document.getElementById('ModalSearchInput');
  var searchResults = document.getElementById('ModalSearchResults');
  var sugTarget     = document.getElementById('SmSuggestionsTarget');
  var prodTarget    = document.getElementById('SmProductsTarget');

  // Expose toggle functions globally so your HTML button clicks find them
  window.openSearchModal = function() {
    if (searchOverlay) {
      searchOverlay.style.display = 'block';
      if (searchInput) searchInput.focus();
      document.body.style.overflow = 'hidden';
    }
  };

  window.closeSearchModal = function() {
    if (searchOverlay) {
      searchOverlay.style.display = 'none';
      if (searchInput) searchInput.value = '';
      if (searchResults) searchResults.style.display = 'none';
      document.body.style.overflow = '';
    }
  };

  if (searchOverlay) {
    searchOverlay.addEventListener('click', function(e) {
      if (e.target === searchOverlay) window.closeSearchModal();
    });
  }

  if (searchInput) {
    searchInput.addEventListener('input', function(e) {
      var query = e.target.value.trim();

      if (!searchResults || !sugTarget || !prodTarget) return;

      if (query.length < 2) {
        searchResults.style.display = 'none';
        return;
      }

      // Query standard predictive suggest architecture natively
      fetch('/search/suggest.json?q=' + encodeURIComponent(query) + '&resources[type]=product,article,query&resources[limit]=5')
        .then(function(res) { return res.json(); })
        .then(function(data) {
          var results = data.resources && data.resources.results ? data.resources.results : {};
          var products = results.products || [];
          var articles = results.articles || [];
          var queries  = results.queries || [];

          // Column 1: Suggestions & Articles
          if (articles.length === 0 && queries.length === 0) {
            sugTarget.innerHTML = '<div class="sm-no-match">No matching options found</div>';
          } else {
            var sugHtml = '';
            queries.forEach(function(item) {
              sugHtml += '<a href="/search?q=' + encodeURIComponent(item.text) + '" class="sm-list-link"><strong>' + item.text + '</strong></a>';
            });
            articles.forEach(function(item) {
              sugHtml += '<a href="' + item.url + '" class="sm-list-link">' + item.title + '</a>';
            });
            sugTarget.innerHTML = sugHtml;
          }

          // Column 2: Products
          if (products.length === 0) {
            prodTarget.innerHTML = '<div class="sm-no-match">No products found</div>';
          } else {
            var prodHtml = '';
            products.forEach(function(item) {
              var fallbackImg = 'data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="40" height="52" viewBox="0 0 24 24" fill="none" stroke="%23ccc"><rect width="18" height="18" x="3" y="3" rx="2"/></svg>';
              var img = item.image ? item.image : fallbackImg;
              prodHtml += '<a href="' + item.url + '" class="sm-prod-card">' +
                '<img src="' + img + '" class="sm-prod-img" alt="">' +
                '<div style="min-width: 0; flex: 1;">' +
                  '<p class="sm-prod-title">' + item.title + '</p>' +
                '</div>' +
              '</a>';
            });
            prodTarget.innerHTML = prodHtml;
          }

          searchResults.style.display = 'block';
        })
        .catch(function(err) {
          console.error('Dynamic overlay fetch process error:', err);
        });
    });
  }

  // ── MOBILE NAV ────────────────────────────────────────────────
  var mBtn = document.querySelector('.hdr-mobile');
  var nav  = document.querySelector('.hdr-nav');
  if(mBtn && nav){
    mBtn.addEventListener('click',function(){
      var open = nav.classList.toggle('open');
      mBtn.setAttribute('aria-expanded', open);
    });
    nav.querySelectorAll('.hdr-nav__item').forEach(function(item){
      var lnk = item.querySelector('.hdr-nav__link');
      if(item.querySelector('.hdr-drop') && lnk){
        lnk.addEventListener('click',function(e){
          if(window.innerWidth < 769){ e.preventDefault(); item.classList.toggle('open'); }
        });
      }
    });
  }

  // ── ANNOUNCEMENT DISMISS ──────────────────────────────────────
  var annX = document.querySelector('.ann__x');
  var ann  = document.querySelector('.ann');
  if(annX && ann){
    if(sessionStorage.getItem('ann-off')) ann.style.display='none';
    annX.addEventListener('click',function(){ ann.style.display='none'; sessionStorage.setItem('ann-off','1'); });
  }

  // ── TABS ──────────────────────────────────────────────────────
  document.querySelectorAll('[data-tabs]').forEach(function(wrap){
    var btns   = wrap.querySelectorAll('.tabs__btn');
    var panels = wrap.querySelectorAll('.tabs__panel');
    btns.forEach(function(btn, i){
      btn.addEventListener('click',function(){
        btns.forEach(function(b){ b.classList.remove('active'); });
        panels.forEach(function(p){ p.classList.remove('active'); });
        btn.classList.add('active');
        if(panels[i]) panels[i].classList.add('active');
      });
    });
  });

  // ── STICKY ATC ────────────────────────────────────────────────
  var mainBtn = document.querySelector('.prod-info__add');
  var satc    = document.querySelector('.sticky-atc');
  if(mainBtn && satc && 'IntersectionObserver' in window){
    new IntersectionObserver(function(entries){
      satc.classList.toggle('visible', !entries[0].isIntersecting);
    },{ threshold:0 }).observe(mainBtn);
  }

  // ── PRODUCT GALLERY THUMBS ────────────────────────────────────
  document.querySelectorAll('.prod-gal__thumb').forEach(function(thumb){
    thumb.addEventListener('click',function(){
      var main = document.querySelector('.prod-gal__main img');
      if(main) main.src = thumb.dataset.full || thumb.src;
      document.querySelectorAll('.prod-gal__thumb').forEach(function(t){ t.classList.remove('active'); });
      thumb.classList.add('active');
    });
  });

  // ── VARIANT PILLS ─────────────────────────────────────────────
  document.querySelectorAll('.prod-info__opt').forEach(function(optGroup){
    var btns   = optGroup.querySelectorAll('.opt-btn');
    var select = document.querySelector('#ProdVarSelect');

    btns.forEach(function(btn){
      btn.addEventListener('click', function(){
        btns.forEach(function(b){ b.classList.remove('active'); });
        btn.classList.add('active');

        var radio = btn.querySelector('input[type="radio"]');
        if(radio){
          radio.checked = true;
          radio.dispatchEvent(new Event('change', { bubbles:true }));
        }

        if(select){
          var val = btn.textContent.trim();
          for(var i=0; i<select.options.length; i++){
            if(select.options[i].text.includes(val)){
              select.selectedIndex = i;
              select.dispatchEvent(new Event('change', { bubbles:true }));
              break;
            }
          }
        }
      });
    });
  });

  // ── GALLERY LIGHTBOX ──────────────────────────────────────────
  document.querySelectorAll('.gal-item').forEach(function(item){
    item.addEventListener('click',function(){
      var src = item.querySelector('img').src;
      var lb  = document.createElement('div');
      lb.style.cssText = 'position:fixed;inset:0;background:rgba(0,0,0,.9);z-index:9999;display:flex;align-items:center;justify-content:center;cursor:zoom-out;padding:20px';
      var img = document.createElement('img');
      img.src = src;
      img.style.cssText = 'max-width:90vw;max-height:90vh;object-fit:contain;border-radius:4px';
      lb.appendChild(img);
      lb.addEventListener('click',function(){ document.body.removeChild(lb); });
      document.body.appendChild(lb);
    });
  });

  // ── COUNTER ANIMATION ─────────────────────────────────────────
  if('IntersectionObserver' in window){
    var obs = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if(!e.isIntersecting) return;
        var el  = e.target;
        var end = parseFloat(el.dataset.count || 0);
        var suf = el.dataset.suffix || '';
        var steps = 60, step = 0;
        var timer = setInterval(function(){
          step++;
          el.textContent = Math.round(end*(step/steps)) + suf;
          if(step >= steps){ clearInterval(timer); el.textContent = end + suf; }
        }, 1800/steps);
        obs.unobserve(el);
      });
    },{ threshold:.5 });
    document.querySelectorAll('.stat-num[data-count]').forEach(function(el){ obs.observe(el); });
  }

  // ── MOBILE PRODUCT CAROUSEL ───────────────────────────────────
  function initCarousels(){
    document.querySelectorAll('.carousel-wrap').forEach(function(wrap){
      var carousel = wrap.querySelector('.carousel');
      var dotsWrap = wrap.querySelector('.carousel-dots');
      var prevBtn  = wrap.querySelector('.carousel-prev');
      var nextBtn  = wrap.querySelector('.carousel-next');
      if(!carousel) return;

      var cards = carousel.querySelectorAll('.prod-card, .course-card');
      if(cards.length === 0) return;

      // Build dots
      if(dotsWrap){
        dotsWrap.innerHTML = '';
        cards.forEach(function(_,i){
          var dot = document.createElement('button');
          dot.className = 'carousel-dot' + (i===0?' active':'');
          dot.setAttribute('aria-label','Item '+(i+1));
          dot.addEventListener('click',(function(idx){ return function(){ scrollTo(idx); }; })(i));
          dotsWrap.appendChild(dot);
        });
      }

      function scrollTo(idx){
        var card = cards[idx];
        if(!card) return;
        carousel.scrollTo({ left: card.offsetLeft - 18, behavior:'smooth' });
      }

      var ticking = false;
      carousel.addEventListener('scroll',function(){
        if(ticking) return;
        ticking = true;
        requestAnimationFrame(function(){
          var center = carousel.scrollLeft + carousel.offsetWidth/2;
          var closest = 0, minDist = Infinity;
          cards.forEach(function(card,i){
            var dist = Math.abs(card.offsetLeft + card.offsetWidth/2 - center);
            if(dist < minDist){ minDist=dist; closest=i; }
          });
          if(dotsWrap){
            dotsWrap.querySelectorAll('.carousel-dot').forEach(function(d,i){
              d.classList.toggle('active', i===closest);
            });
          }
          ticking = false;
        });
      });

      if(prevBtn) prevBtn.addEventListener('click',function(){
        carousel.scrollBy({ left: -carousel.offsetWidth*.8, behavior:'smooth' });
      });
      if(nextBtn) nextBtn.addEventListener('click',function(){
        carousel.scrollBy({ left: carousel.offsetWidth*.8, behavior:'smooth' });
      });
    });
  }

  initCarousels();

})();